import { render, staticRenderFns } from "./EventRecycleDialog.vue?vue&type=template&id=7130d274&scoped=true"
import script from "./EventRecycleDialog.vue?vue&type=script&lang=js"
export * from "./EventRecycleDialog.vue?vue&type=script&lang=js"
import style0 from "./EventRecycleDialog.vue?vue&type=style&index=0&id=7130d274&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../2026-08-26/github-cli-gh-codex/work/jiangkv3/web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7130d274",
  null
  
)

export default component.exports